import { FC } from "react";
import { useAppStore } from "store/store";

import StyledInfoPage from "./styles/StyledInfoPage.styled";
import useItemLevelNavigationState, {
  ItemNavigationState,
} from "features/shared/hooks/navigation/useItemLevelNavigationState";
import { ItemLevelNavigationError } from "models/navigation/item-navigation-error";
import usePaxSession from "features/shared/hooks/usePaxSession";
import { InfoItem } from "models/checklist/checklist-item/checklist-item";
import { useSearchParams } from "react-router-dom";
import InfoCard from "./InfoCard";

const InfoPage: FC = () => {
  useAppStore((state) => state.locale);

  const [searchParams] = useSearchParams();
  const itemLevelNavigationState = useItemLevelNavigationState(searchParams);

  const sessionId = useAppStore((state) => state.sessionId);
  const paxSessionId = usePaxSession()?.paxSessionId;

  // InfoPage currently only supports navigation by item id for now
  if (itemLevelNavigationState instanceof ItemNavigationState === false) {
    throw new ItemLevelNavigationError(
      sessionId,
      paxSessionId,
      "Info page can only be used with itemId"
    );
  }

  const item = (itemLevelNavigationState as ItemNavigationState).item;

  if (item instanceof InfoItem === false) {
    throw new ItemLevelNavigationError(
      sessionId,
      paxSessionId,
      `Item is not info, item id: ${item.id}`
    );
  }

  return (
    <StyledInfoPage>
      <InfoCard item={item} />
    </StyledInfoPage>
  );
};

export default InfoPage;
